import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {
  private socket!: Socket;

  constructor() {}

  connect(): void {
    if (this.socket && this.socket.connected) {
      return; // evita reconexión doble
    }

    this.socket = io(environment.apis.socketUrl, {
      transports: ['websocket'] // fuerza usar WebSocket
    });

    this.socket.on('connect', () => {
      console.log('✅ Conectado al servidor:', this.socket.id);
    });

    this.socket.on('disconnect', () => {
      console.log('❌ Desconectado del servidor');
    });
  }

  disconnect(): void {
    if (this.socket && this.socket.connected) {
      console.log('🔌 Cerrando conexión WebSocket...');
      this.socket.disconnect();
    }
  }

  /** 🔹 Quita un listener específico para evitar duplicados */
  off(event: string): void {
    if (this.socket) {
      this.socket.off(event);
      console.log(`🧹 Listener eliminado`);
    }
  }

  // 🔹 Emitir eventos
  emit(event: string, ...args: any[]): void {
    this.socket.emit(event, ...args);
  }

  // 🔹 Escuchar eventos
  listen<T>(event: string): Observable<T> {
    return new Observable<T>((subscriber) => {
      this.socket.on(event, (data: T) => {
        subscriber.next(data);
      });
    });
  }
}
